export const features = [
  'group engagement',
  '🎉',
  'interactive learning',
  'word clouds',
  'poll the audience',
  'trivia and quizzes',
  'icebreakers',
  'classroom games',
  'fun',
  'interactive',
  'team building',
  'brainstorm'
]

export const benefits = [
  'Engagement you can feel',
  'Group connection and fun',
  'Easy to host, easy to play',
  'Results you can show',
  ///
  'Engagement you can see', 'Engagement you can feel',
  'Results you can show',
  'Simple to use', 'Easy to host and build', 'easy to get started',
  'makes you look good', 'Look good (with no work)', 'design & styling to make you look good',
  'Give everyone a voice', 'hear from everyone',
  'Easily keep your audience focused', 'keep attention on you', 'be the focus',
  'Measurable interaction', 'measurable results', 'provable, measurable engagement',
  'Go from boring to fun', 'make it fun',
  'Bring everyone together', 'align your team', 'connect your group',
  'prosocial', 'connective', 'community'
]
